export interface HeroAspectRatioOption {
  value: string;
  label: string;
}

export const HERO_ASPECT_RATIO_OPTIONS: readonly HeroAspectRatioOption[] = [
  { value: 'aspect_5-1', label: 'Panorámico 5:1' },
  { value: 'aspect_4-1', label: 'Panorámico 4:1' },
  { value: 'aspect_3-1', label: 'Panorámico 3:1' },
  { value: 'aspect_25-11', label: 'Panorámico 25:11' },
  { value: 'aspect_16-9', label: 'Horizontal 16:9' },
  { value: 'aspect_8-5', label: 'Horizontal 8:5' },
  { value: 'aspect_4-3', label: 'Horizontal 4:3' },
  { value: 'aspect_3-2', label: 'Horizontal 3:2' },
  { value: 'aspect_1-1', label: 'Cuadrado 1:1' },
  // { value: 'aspect_3-4', label: 'Vertical 3:4' },
  // { value: 'aspect_2-3', label: 'Vertical 2:3' },
  // { value: 'aspect_5-8', label: 'Vertical 5:8' },
  // { value: 'aspect_9-16', label: 'Vertical 9:16' },
  // { value: 'aspect_11-25', label: 'Vertical 11:25' },
  // { value: 'aspect_1-5', label: 'Vertical 1:5' },
];
